import React from "react";
import { Component, Fragment } from "react";
import {
	Progress,
	Card,
	CardBody,
  CardTitle,
	Input,
	Row,
	Col,
	Button,
	ListGroup,
	ListGroupItem,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
	Tooltip
} from 'reactstrap';

import img1 from '../../../assets/images/background/active-bg.png';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Moment from 'moment';
import {
	appendProductFilter,
	beginDashboardRequest,
	finishDashboardRequest,
	markDashboardRequestSucceeded,
	getDashboardRefreshWait,
	getDeviceProductType,
	getStoredProductType,
	ignoreDashboardRequestError,
	isDashboardRequestCurrent,
	scheduleDashboardRetry,
	stopDashboardPolling,
	PRODUCT_TYPE_ALL,
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../product-filter';
import {
	filterDevicesByProductType,
	filterProceduresForCategory,
	findDeviceBySerial,
	getRevenueCategoryIDs,
	getRoiEndpointName,
	getRoiRequestProductType,
	normalizeRoiProcedures,
	reconcileDeviceRevenue,
	toRoiNumber
} from './return-on-investment-helpers';
import DashboardCardLoader from '../dashboard-card-loader';
import CenteredBlackDropdown from '../../mobile-vitals-dashboard/centered-black-dropdown/centered-black-dropdown';
var moment = require('moment-timezone');

const EVO_CATEGORY_OPTIONS = [
	{ label: "Non Surgical", value: "1-1", categoryID: 1, productID: PRODUCT_TYPE_EVO },
	{ label: "Surgical", value: "1-2", categoryID: 2, productID: PRODUCT_TYPE_EVO },
	{ label: "Pain Relief", value: "1-3", categoryID: 3, productID: PRODUCT_TYPE_EVO },
];

const NOVA_CATEGORY_OPTIONS = [
	{ label: "Non Surgical", value: "2-1", categoryID: 1, productID: PRODUCT_TYPE_NOVA },
	{ label: "Surgical", value: "2-2", categoryID: 2, productID: PRODUCT_TYPE_NOVA },
	{ label: "Hygiene", value: "2-4", categoryID: 4, productID: PRODUCT_TYPE_NOVA },
	{ label: "Orthodontics", value: "2-5", categoryID: 5, productID: PRODUCT_TYPE_NOVA },
];

const ALL_CATEGORY_OPTIONS = [
	{ label: "EVO - Non Surgical", value: "1-1", categoryID: 1, productID: PRODUCT_TYPE_EVO },
	{ label: "EVO - Surgical", value: "1-2", categoryID: 2, productID: PRODUCT_TYPE_EVO },
	{ label: "EVO - Pain Relief", value: "1-3", categoryID: 3, productID: PRODUCT_TYPE_EVO },
	{ label: "Nova - Non Surgical", value: "2-1", categoryID: 1, productID: PRODUCT_TYPE_NOVA },
	{ label: "Nova - Surgical", value: "2-2", categoryID: 2, productID: PRODUCT_TYPE_NOVA },
	{ label: "Nova - Hygiene", value: "2-4", categoryID: 4, productID: PRODUCT_TYPE_NOVA },
	{ label: "Nova - Orthodontics", value: "2-5", categoryID: 5, productID: PRODUCT_TYPE_NOVA },
];

var currency_list = [
		{"name":"US Dollar","code":"USD","symbol":"$"},
		{"name":"Argentine Peso","code":"ARS","symbol":"$"},
		{"name":"Argentine Peso","code":"ARS","symbol":"$"},
	    {"name":"Australian Dollar","code":"AUD","symbol":"$"},
	    {"name":"Belgian Franc","code":"BEF","symbol":"fr"},
	    {"name":"Bolivian Boliviano","code":"BOB","symbol":"Bs."},
	    {"name":"Brazilian Real","code":"BRL","symbol":"R$"},
	    {"name":"British Pound Sterling","code":"GBP","symbol":"£"},
     {"name":"Canadian Dollar","code":"CAD","symbol":"$"},
	     {"name":"Cayman Islands Dollar","code":"KYD","symbol":"$"},
	     {"name":"Chilean Peso","code":"CLP","symbol":"$"},
	     {"name":"Chinese Yuan","code":"CNY","symbol":"¥"},
	     {"name":"Colombian Peso","code":"COP","symbol":"$"},
	     {"name":"Dominican Peso","code":"DOP","symbol":"$"},
	     {"name":"Euro","code":"EUR","symbol":"€"},
	     {"name":"German Mark","code":"DEM","symbol":"DM"},
	     {"name":"Israeli New Sheqel","code":"ILS","symbol":"₪"},
	     {"name":"Italian Lira","code":"ITL","symbol":"L,£"},
	     {"name":"Japanese Yen","code":"JPY","symbol":"¥"},
	     {"name":"Jordanian Dinar","code":"JOD","symbol":"ا.د"},
	     {"name":"Kuwaiti Dinar","code":"KWD","symbol":"ك.د"},
	     {"name":"Macedonian Denar","code":"MKD","symbol":"ден"},
	     {"name":"Mexican Peso","code":"MXN","symbol":"$"},
	     {"name":"New Zealand Dollar","code":"NZD","symbol":"$"},
	     {"name":"Omani Rial","code":"OMR","symbol":".ع.ر"},
	     {"name":"Swiss Franc","code":"CHF","symbol":"CHf"},
	     {"name":"United Arab Emirates Dirham","code":"AED","symbol":"إ.د"}
];

class ReturnOnInvestment extends React.Component {

	noResults = true;
	intervalID = 0;

	constructor(props) {
    super(props);
		const productType = getStoredProductType();
    this.state = {
			rSelected: parseInt(productType) === PRODUCT_TYPE_NOVA ? "2-2" : "1-2",
			allProcedures: [],
			nonSurgicalProcedures: [],
			surgicalProcedures: [],
			painReliefProcedures: [],
			savedProcedures: [],
			colors: [{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}],
			noDevices: false,
			noDataForDevices: false,
			totalSavings: 0,
			currentDevice: this.props.currentDevice,
			currentDataSetting: 0,
			currentDataSetting2: 0,
			startDate: Moment().subtract(3, 'year').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			isOpen2: false,
			currentItem: "Global",
			currentItem2: "All Devices",
			selectedDeviceSerial: null,
			tooltipOpen: false,
			userCurrency: "USD",
			userCurrencySymbol: "$",
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			productType,
			isLoading: false
	  };

		this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.toggleDropDown2 = this.toggleDropDown2.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleProductTypeChange = this.handleProductTypeChange.bind(this);

		this.toggleTooltip = this.toggleTooltip.bind(this);
  }

	async componentDidMount() {
		document.body.addEventListener('set-product-type', this.handleProductTypeChange);

		if (this.state.currentUser) {
			this.getUserCurrency();
			this.getDeviceList();
			this.scheduleDataRefresh(this.state.rSelected);
		} else {
			setTimeout(()=>{ this.getUserCurrency(); }, 1000);
			setTimeout(()=>{ this.getDeviceList(); }, 1000);
			this.scheduleDataRefresh(this.state.rSelected);
		}
	}

	scheduleDataRefresh(category, delay, showLoader = true) {
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (showLoader) {
			this.setState({ isLoading: true });
		}
		this.dashboardRefreshTimeout = setTimeout(()=>{ this.getData(category, { showLoader }); }, delay || getDashboardRefreshWait('returnOnInvestment'));
	}

	handleProductTypeChange(event) {
		const productType = event.detail.id;
		const categoryOptions = this.getCategoryOptions(productType);
		const selectedCategory = categoryOptions.find(option => option.value === this.state.rSelected);
		const rSelected = selectedCategory ? this.state.rSelected : this.getDefaultCategoryValue(productType);
		this.setState({
			productType,
			rSelected,
			currentItem2: "All Devices",
			currentDataSetting2: 0,
			selectedDeviceSerial: null
		}, () => this.scheduleDataRefresh(rSelected));
  }

	getDeviceList = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"device-list";

		var token = "";

		if (this.state.currentUser) {
			token = this.state.currentUser.jwtToken;
		}

		if (this.props.authToken) {
			console.log("ReturnOnInvestment this.props.authToken: " + this.props.authToken);
			token = this.props.authToken;
		}

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: token
				},
			});

			const body = await response.json();
			console.log("all devices: " + JSON.stringify(body));

			if (body.status == 'Success') {
				const deviceList = Array.isArray(body.response) ? body.response : [];
				this.setState({
					deviceList,
					noDevices: deviceList.length === 0
				});
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log("getDeviceList error: "+err);
		}

	};

	getUserCurrency = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-user-currency";

		var token = "";

		if (this.state.currentUser) {
			token = this.state.currentUser.jwtToken;
		}

		if (this.props.authToken) {
			console.log("ReturnOnInvestment this.props.authToken: " + this.props.authToken);
			token = this.props.authToken;
		}

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: token
				},
			});

			const body = await response.json();
			console.log("getUserCurrency response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				if (body.results.length>0) {
					let currency = currency_list.find(c => c.code === body.results[0].Currency);
					this.setState({ userCurrency: body.results[0].Currency, userCurrencySymbol: currency.symbol})
				} else {
					let currency = currency_list.find(c => c.code === 'USD');
					this.setState({ userCurrency: 'USD', userCurrencySymbol: currency.symbol})
				}

			} else {

			}

		}
		catch (err) {
			console.log(err);
		}

	};

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	toggleDropDown2() {
    this.setState({
      isOpen2: !this.state.isOpen2
    });
  }

	handleChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({startDate: event.target.value});
			this.setState({
	      currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({endDate: event.target.value});
			this.setState({
				currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		}

		this.scheduleDataRefresh(this.state.rSelected);
  }

	handleSubmit(event) {

		this.getData(this.state.rSelected, { showLoader: true });
  }

	selectDropDownItem(id, title) {

    this.setState({
      currentItem: title,
			currentDataSetting: id
    });

		if (id==1) {
			this.setState({ startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD') });
		} else if (id==2) {
			this.setState({ startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD') });
		} else if (id==3) {
			this.setState({ startDate: Moment().format('YYYY-MM-DD') });
		}

		this.setState({ endDate: Moment().format('YYYY-MM-DD') });

		this.scheduleDataRefresh(this.state.rSelected);
  }

	selectDropDownItem2(id, title) {
		const selectedDeviceSerial = id === 0 ? null : title;
		const selectedDevice = findDeviceBySerial(this.state.deviceList, selectedDeviceSerial);
		const selectedDeviceProductType = getDeviceProductType(selectedDevice);
		const selectedCategory = this.getSelectedCategoryOption();
		const shouldResetCategory = selectedDeviceSerial !== null &&
			parseInt(this.state.productType) === PRODUCT_TYPE_ALL &&
			selectedDeviceProductType !== PRODUCT_TYPE_ALL &&
			selectedCategory.productID !== selectedDeviceProductType;
		const rSelected = shouldResetCategory
			? this.getDefaultCategoryValue(selectedDeviceProductType)
			: this.state.rSelected;

		this.setState({
			currentItem2: title,
			currentDataSetting2: id,
			selectedDeviceSerial,
			rSelected
		}, () => this.scheduleDataRefresh(rSelected));
	  }

	stepBack () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}

		this.scheduleDataRefresh(this.state.rSelected);
	}

	stepForward () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}

		this.scheduleDataRefresh(this.state.rSelected);
	}

	componentWillUnmount() {
		//console.log("ROI componentWillUnmount");
		clearInterval(this.intervalID);
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (this.dashboardAbortController) {
			this.dashboardAbortController.abort();
		}
		document.body.removeEventListener('set-product-type', this.handleProductTypeChange);
	}

	onRadioBtnClick(rSelected) {
		this.setState({ rSelected }, () => this.getData(rSelected, { showLoader: true }));
	}

	getCategoryOptions(productType = this.state.productType) {
		switch (parseInt(productType)) {
			case PRODUCT_TYPE_EVO:
				return EVO_CATEGORY_OPTIONS;
			case PRODUCT_TYPE_NOVA:
				return NOVA_CATEGORY_OPTIONS;
			default:
				return ALL_CATEGORY_OPTIONS;
		}
	}

	getDefaultCategoryValue(productType = this.state.productType) {
		return parseInt(productType) === PRODUCT_TYPE_NOVA ? "2-2" : "1-2";
	}

	getSelectedCategoryOption(categoryValue = this.state.rSelected) {
		const categoryOptions = this.getCategoryOptions();
		return categoryOptions.find(option => option.value === categoryValue) || categoryOptions[0];
	}

	getSelectedProcedures() {
		const selectedCategory = this.getSelectedCategoryOption();
		return filterProceduresForCategory(this.state.allProcedures, selectedCategory);
	}

	getRevenueDevices() {
		const filteredDevices = filterDevicesByProductType(this.state.deviceList, this.state.productType);

		if (this.state.selectedDeviceSerial === null) {
			return filteredDevices;
		}

		const selectedDevice = findDeviceBySerial(filteredDevices, this.state.selectedDeviceSerial) ||
			findDeviceBySerial(this.state.deviceList, this.state.selectedDeviceSerial);

		return selectedDevice ? [selectedDevice] : [];
	}

	fetchRevenueJson = async (url, token, signal) => {
		const response = await fetch(url, {
			method: 'GET',
			signal,
			headers: {
				Authorization: token
			},
		});

		return response.json();
	}

	getDeviceRevenueProcedures = async ({ device, roiProcedures, apiBaseUrl, token, signal, isDateRange }) => {
		const serialNumber = String(device.SerialNumber);
		const productType = getDeviceProductType(device);
		const categoryIDs = getRevenueCategoryIDs(productType);
		const pricingUrl = appendProductFilter(
			apiBaseUrl + 'all-procedures-for-device?SerialNumber=' + encodeURIComponent(serialNumber),
			productType
		);
		const pricingRequest = this.fetchRevenueJson(pricingUrl, token, signal).catch(() => ({ status: 'Error', results: [] }));
		const countRequests = categoryIDs.map(categoryID => {
			const endpointName = isDateRange
				? 'top-procedures-by-category-for-device-date-range'
				: 'top-procedures-by-category-for-device';
			const queryParameters = [
				'SerialNumber=' + encodeURIComponent(serialNumber),
				'CategoryId=' + encodeURIComponent(categoryID)
			];

			if (isDateRange) {
				queryParameters.push('StartDate=' + encodeURIComponent(this.state.startDate));
				queryParameters.push('EndDate=' + encodeURIComponent(this.state.endDate));
				queryParameters.push('Timezone=' + encodeURIComponent(Moment.tz.guess()));
			}

			const countUrl = appendProductFilter(
				apiBaseUrl + endpointName + '?' + queryParameters.join('&'),
				productType
			);
			return this.fetchRevenueJson(countUrl, token, signal)
				.then(body => ({ body, categoryID }))
				.catch(() => ({ body: { status: 'Error', results: [] }, categoryID }));
		});
		const responses = await Promise.all([pricingRequest].concat(countRequests));
		const pricingBody = responses[0];
		const pricingProcedures = pricingBody.status === 'Success'
			? (pricingBody.results || []).filter(procedure => {
				return procedure.Name &&
					(procedure.PresetProcedureID !== undefined || procedure.OBJID !== undefined) &&
					categoryIDs.includes(parseInt(procedure.CategoryID));
			})
			: [];
		const countProcedures = responses.slice(1).reduce((procedures, response) => {
			if (response.body.status !== 'Success') {
				return procedures;
			}

			return procedures.concat((response.body.results || []).map(procedure => ({
				...procedure,
				CategoryID: response.categoryID
			})));
		}, []);
		if (pricingProcedures.length === 0) {
			return null;
		}
		const deviceRoiProcedures = roiProcedures.filter(procedure => {
			return !procedure.SerialNumber || String(procedure.SerialNumber) === serialNumber;
		});

		return reconcileDeviceRevenue({
			roiProcedures: deviceRoiProcedures,
			pricingProcedures,
			countProcedures,
			serialNumber,
			productType
		});
	}

	getReconciledRevenueProcedures = async ({ roiProcedures, apiBaseUrl, token, signal, isDateRange }) => {
		const devices = this.getRevenueDevices();
		if (devices.length === 0) {
			return roiProcedures;
		}

		const deviceProcedures = await Promise.all(devices.map(device => this.getDeviceRevenueProcedures({
			device,
			roiProcedures,
			apiBaseUrl,
			token,
			signal,
			isDateRange
		})));
		if (deviceProcedures.some(procedures => !Array.isArray(procedures))) {
			return roiProcedures;
		}

		const reconciledProcedures = deviceProcedures.reduce((procedures, currentProcedures) => {
			return procedures.concat(currentProcedures);
		}, []);

		return reconciledProcedures.length > 0 ? reconciledProcedures : roiProcedures;
	}

	getData = async (category, options = {}) => {
		const request = beginDashboardRequest(this, options.showLoader === true);
		const signal = request.controller.signal;
		const isDateRange = this.state.currentDataSetting !== 0;
		const isAllDevices = this.state.selectedDeviceSerial === null;
		const endpointName = getRoiEndpointName({ isDateRange, isAllDevices });
		const configuredProductType = this.props.productID || this.props.product;
		const requestProductType = getRoiRequestProductType({
			headerProductType: this.state.productType,
			selectedSerialNumber: this.state.selectedDeviceSerial,
			devices: this.state.deviceList,
			fallbackProductType: configuredProductType
		});
		const queryParameters = [];

		if (!isAllDevices) {
			queryParameters.push('SerialNumber=' + encodeURIComponent(this.state.selectedDeviceSerial));
		}

		if (isDateRange) {
			queryParameters.push('StartDate=' + encodeURIComponent(this.state.startDate));
			queryParameters.push('EndDate=' + encodeURIComponent(this.state.endDate));
			queryParameters.push('Timezone=' + encodeURIComponent(Moment.tz.guess()));
		}

		const apiBaseUrl = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com" + process.env.REACT_APP_ENV;
		const baseUrl = apiBaseUrl + endpointName + (queryParameters.length ? '?' + queryParameters.join('&') : '');
		const url = appendProductFilter(baseUrl, requestProductType);
		const token = this.props.authToken || (this.state.currentUser && this.state.currentUser.jwtToken) || "";

		try {
			const response = await fetch(url, {
				method: 'GET',
				signal,
				headers: {
					Authorization: token
				},
			});

			const body = await response.json();
			if (!isDashboardRequestCurrent(this, request.requestId)) {
				return;
			}

			console.log(endpointName + " response: " + JSON.stringify(body));

			if (body.status === 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);
				const roiProcedures = normalizeRoiProcedures(body.results);
				const procedures = await this.getReconciledRevenueProcedures({
					roiProcedures,
					apiBaseUrl,
					token,
					signal,
					isDateRange
				});
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				const totalSavings = procedures.reduce((grandTotal, procedure) => grandTotal + procedure.Amount, 0);

				this.setState({
					allProcedures: procedures,
					nonSurgicalProcedures: procedures.filter(procedure => procedure.CategoryID === 1),
					surgicalProcedures: procedures.filter(procedure => procedure.CategoryID === 2),
					painReliefProcedures: procedures.filter(procedure => procedure.CategoryID === 3),
					totalSavings,
					noDataForDevices: procedures.length === 0
				});
			} else {
				this.setState({
					allProcedures: [],
					nonSurgicalProcedures: [],
					surgicalProcedures: [],
					painReliefProcedures: [],
					totalSavings: 0,
					noDataForDevices: true
				});
			}
		}
		catch (err) {
			if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData(category, { showLoader: true }))) {
				console.log(err);
			}
		}
		finally {
			finishDashboardRequest(this, request.requestId, () => this.getData(category, { showLoader: false }));
		}
	};

	getColor(categoryID) {

		var color = "success";

		if (categoryID==1) {
			color = "success";
		} else if (categoryID==2) {
			color = "info";
		} else if (categoryID==3) {
			color = "yellow";
		}

		return color;

	}

	getBarValue(procedure) {
		const goal = toRoiNumber(procedure.Goal);
		if (goal <= 0) {
			return 0;
		}

		return (toRoiNumber(procedure.Amount) / goal) * 100;

	}

	getGoalText(procedure) {

		var color = "success";

		return color;

	}

	render() {
		const categoryOptions = this.getCategoryOptions();
		const selectedCategory = this.getSelectedCategoryOption();
		const selectedCategoryID = selectedCategory.categoryID;
		const selectedProcedures = this.getSelectedProcedures();
		const filteredDeviceList = filterDevicesByProductType(this.state.deviceList, this.state.productType);

		return (
			/*--------------------------------------------------------------------------------*/
			/* Used In Dashboard-1 [Classic]                                                  */
			/*--------------------------------------------------------------------------------*/
			<Card className="card-hover">
				<CardBody style={{ minHeight: 650 }}>
					<Row style={{
						position: 'relative',
						zIndex: this.state.isOpen || this.state.isOpen2 ? 1100 : 'auto'
					}}>
						<Col xs="6" className="text-left">
							<CardTitle>Revenue Generated
							<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="RevenueGeneratedTooltip"/>
							<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="RevenueGeneratedTooltip" toggle={this.toggleTooltip}>
								View revenue generated by procedure. Requires initial designation of fee charged by procedure under Your Devices The Name of Your Laser Unit Customize.
							</Tooltip>
							</CardTitle>
						</Col>
						<Col xs="6" className="text-right">
							<div>
							<ButtonDropdown size="sm" className="ml-1 mr-1" isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
								<DropdownToggle color="dark" caret>
									{this.state.currentItem}
								</DropdownToggle>
								<DropdownMenu right>
									<DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(1, 'By Week')}>By Week</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(2, 'By Month')}>By Month</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(3, 'Custom Range')}>Custom Range</DropdownItem>
								</DropdownMenu>
							</ButtonDropdown>
							{this.state.deviceList &&
								<ButtonDropdown size="sm" isOpen={this.state.isOpen2} toggle={this.toggleDropDown2}>
									<DropdownToggle color="dark" caret>
										{this.state.currentItem2}
									</DropdownToggle>
									<DropdownMenu right>
										<DropdownItem onClick={() => this.selectDropDownItem2(0, 'All Devices')}>All Devices</DropdownItem>
										{filteredDeviceList.map((device, i) => (
											<DropdownItem key={String(device.SerialNumber)} onClick={() => this.selectDropDownItem2(i+1, device.SerialNumber)}>{device.SerialNumber}</DropdownItem>
										))}
									</DropdownMenu>
								</ButtonDropdown>
							}
							</div>
						</Col>
					</Row>
					<Row>
						<Col xs="12" md="12" lg="12" className="text-center mt-1">
							{!this.state.noDevices && !this.state.noDataForDevices &&
								<CardTitle style={{color:'#ffc10e'}}>Total: {this.state.userCurrencySymbol}{this.state.totalSavings.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</CardTitle>
							}
						</Col>
					</Row>
					<Row className="pt-1" style={{ position: 'relative', zIndex: 1000 }}>
						<Col xs="12" md="12" lg="12">
							<div className="mt-1 mb-1" style={{ transform: 'translateY(-10px)' }}>
								<CenteredBlackDropdown
									options={categoryOptions}
									value={this.state.rSelected}
									onChange={(value) => this.onRadioBtnClick(value)}
									placeholder="Select Category"
								/>
							</div>
						</Col>
					</Row>
					{this.state.isLoading ? (
						<DashboardCardLoader />
					) : this.state.noDevices || this.state.noDataForDevices ? (
						<div className="mt-5 text-center">
						{!this.state.noDataForDevices &&
							<h5>User has no devices</h5>
						}
						{this.state.noDataForDevices &&
							<h5>No data for user's devices</h5>
						}
						</div>
					) : (
						<div className="pt-3" style={{height: '412px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '4px'}}>
							{this.state.currentDataSetting == 0 || this.state.currentDataSetting == 3 ? (
								<Fragment>
								{selectedCategoryID === 1 &&
									<Fragment>
									{selectedProcedures.map((procedure, i) => (
										<Fragment>
										<Row key={i} className={i>0 ? "mt-3" : ""}>
											<Col xs="12">
												<div className="text-left" style={{ width: "30%", float: "left" }}>
													{procedure.Amount > 0 ? (
														<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(procedure.Amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
													) : (
														<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
													)}
												</div>
												<div className="text-center" style={{ width: "40%", float: "left" }}>
													{procedure.total > 0 && procedure.Price > 0 ? (
														<span>({procedure.Name})</span>
													) : (
														<span>({procedure.Name})</span>
													)}
												</div>
												<div className="text-right" style={{ width: "30%", float: "left" }}>
													{procedure.Amount > 0 ? (
														<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
													) : (
														<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
													)}
												</div>
											</Col>
										</Row>
										{procedure.Goal && procedure.Goal!=0 && procedure.Goal!="" && procedure.total>0 ? (
											<Fragment>
												<Row>
													<Col xs="12" md="12" lg="12" className="text-right">
														<Progress multi className="mt-1 float-left" style={{ height: "10px", width: "100%"}}>
															<Progress bar color={this.getColor(procedure.CategoryID)} value={this.getBarValue(procedure)} />
														</Progress>
														{
															//<span className="float-right" style={{color:'#ffc10e', width: "15%"}}>{this.state.userCurrencySymbol}{procedure.Goal}</span>
														}
													</Col>
												</Row>
											</Fragment>
										) : (
											<Fragment>
											</Fragment>
										)}
										</Fragment>
									))}
									</Fragment>
								}
								{selectedCategoryID === 2 &&
									<Fragment>
									{selectedProcedures.map((procedure, i) => (
										<Fragment>
										<Row key={i} className={i>0 ? "mt-3" : ""}>
											<Col xs="12">
												<div className="text-left" style={{ width: "30%", float: "left" }}>
													{procedure.Amount > 0 ? (
														<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(procedure.Amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
													) : (
														<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
													)}
												</div>
												<div className="text-center" style={{ width: "40%", float: "left" }}>
													{procedure.total > 0 && procedure.Price > 0 ? (
														<span>({procedure.Name})</span>
													) : (
														<span>({procedure.Name})</span>
													)}
												</div>
												<div className="text-right" style={{ width: "30%", float: "left" }}>
													{procedure.Amount > 0 ? (
														<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
													) : (
														<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
													)}
												</div>
											</Col>
										</Row>
										{procedure.Goal && procedure.Goal!=0 && procedure.Goal!="" && procedure.total>0 ? (
											<Fragment>
												<Row>
													<Col xs="12" md="12" lg="12" className="text-right">
														<Progress multi className="mt-1 float-left" style={{ height: "10px", width: "100%"}}>
															<Progress bar color={this.getColor(procedure.CategoryID)} value={this.getBarValue(procedure)} />
														</Progress>
														{
															//<span className="float-right" style={{color:'#ffc10e', width: "15%"}}>{this.state.userCurrencySymbol}{procedure.Goal}</span>
														}
													</Col>
												</Row>
											</Fragment>
										) : (
											<Fragment>
											</Fragment>
										)}
										</Fragment>
									))}
									</Fragment>
								}
								{[3, 4, 5].includes(selectedCategoryID) &&
									<Fragment>
									{selectedProcedures.map((procedure, i) => (
										<Fragment>
										<Row key={i} className={i>0 ? "mt-3" : ""}>
											<Col xs="12">
												<div className="text-left" style={{ width: "30%", float: "left" }}>
													{procedure.Amount > 0 ? (
														<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(procedure.Amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
													) : (
														<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
													)}
												</div>
												<div className="text-center" style={{ width: "40%", float: "left" }}>
													{procedure.total > 0 && procedure.Price > 0 ? (
														<span>({procedure.Name})</span>
													) : (
														<span>({procedure.Name})</span>
													)}
												</div>
												<div className="text-right" style={{ width: "30%", float: "left" }}>
													{procedure.Amount > 0 ? (
														<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
													) : (
														<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
													)}
												</div>
											</Col>
										</Row>
										{procedure.Goal && procedure.Goal!=0 && procedure.Goal!="" && procedure.total>0 ? (
											<Fragment>
												<Row>
													<Col xs="12" md="12" lg="12" className="text-right">
														<Progress multi className="mt-1 float-left" style={{ height: "10px", width: "100%"}}>
															<Progress bar color={this.getColor(procedure.CategoryID)} value={this.getBarValue(procedure)} />
														</Progress>
														{
															//<span className="float-right" style={{color:'#ffc10e', width: "15%"}}>{this.state.userCurrencySymbol}{procedure.Goal}</span>
														}
													</Col>
												</Row>
											</Fragment>
										) : (
											<Fragment>
											</Fragment>
										)}
										</Fragment>
									))}
									</Fragment>
								}
								</Fragment>
							) : (
								<Fragment>
								{selectedCategoryID === 1 &&
									<Fragment>
									<Row className="align-items-center">
										<div style={{ width: '5%', margin: '0 auto', height: '100%' }}>
											<Button size="sm" color="link" onClick={() => this.stepBack()} title="Step Back">
												<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
											</Button>
										</div>
										<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
											<div className="ml-4 mt-1">
													{this.state.noDataForDevices ? (
														<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
															<h5>No data for user's devices</h5>
														</div>
													) : (
														<div className="">
												{selectedProcedures.map((procedure, i) => (
															<Fragment>
															<Row key={i} className={i>0 ? "mt-3" : ""}>
																<Col xs="12">
																	<div className="text-left" style={{ width: "30%", float: "left" }}>
																		{procedure.Amount > 0 ? (
																			<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(procedure.Amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
																		) : (
																			<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
																		)}
																	</div>
																	<div className="text-center" style={{ width: "40%", float: "left" }}>
																		{procedure.total > 0 && procedure.Price > 0 ? (
																			<span>({procedure.Name})</span>
																		) : (
																			<span>({procedure.Name})</span>
																		)}
																	</div>
																	<div className="text-right" style={{ width: "30%", float: "left" }}>
																		{procedure.Amount > 0 ? (
																			<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
																		) : (
																			<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
																		)}
																	</div>
																</Col>
															</Row>
															{procedure.Goal && procedure.Goal!=0 && procedure.Goal!="" && procedure.total>0 ? (
																<Fragment>
																	<Row>
																		<Col xs="12" md="12" lg="12" className="text-right">
																			<Progress multi className="mt-1 float-left" style={{ height: "10px", width: "100%"}}>
																				<Progress bar color={this.getColor(procedure.CategoryID)} value={this.getBarValue(procedure)} />
																			</Progress>
																			{
																				//<span className="float-right" style={{color:'#ffc10e', width: "15%"}}>{this.state.userCurrencySymbol}{procedure.Goal}</span>
																			}
																		</Col>
																	</Row>
																</Fragment>
															) : (
																<Fragment>
																</Fragment>
															)}
															</Fragment>
														))}
														</div>
													)}
											</div>
										</div>
										<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
											<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Step Forward">
												<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
											</Button>
										</div>
									</Row>
									</Fragment>
								}
								{selectedCategoryID === 2 &&
									<Fragment>
									<Row className="align-items-center">
										<div style={{ width: '5%', margin: '0 auto', height: '100%' }}>
											<Button size="sm" color="link" onClick={() => this.stepBack()} title="Step Back">
												<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
											</Button>
										</div>
										<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
											<div className="ml-4 mt-1">
													{this.state.noDataForDevices ? (
														<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
															<h5>No data for user's devices</h5>
														</div>
													) : (
														<div className="">
												{selectedProcedures.map((procedure, i) => (
															<Fragment>
															<Row key={i} className={i>0 ? "mt-3" : ""}>
																<Col xs="12">
																	<div className="text-left" style={{ width: "30%", float: "left" }}>
																		{procedure.Amount > 0 ? (
																			<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(procedure.Amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
																		) : (
																			<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
																		)}
																	</div>
																	<div className="text-center" style={{ width: "40%", float: "left" }}>
																		{procedure.total > 0 && procedure.Price > 0 ? (
																			<span>({procedure.Name})</span>
																		) : (
																			<span>({procedure.Name})</span>
																		)}
																	</div>
																	<div className="text-right" style={{ width: "30%", float: "left" }}>
																		{procedure.Amount > 0 ? (
																			<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
																		) : (
																			<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
																		)}
																	</div>
																</Col>
															</Row>
															{procedure.Goal && procedure.Goal!=0 && procedure.Goal!="" && procedure.total>0 ? (
																<Fragment>
																	<Row>
																		<Col xs="12" md="12" lg="12" className="text-right">
																			<Progress multi className="mt-1 float-left" style={{ height: "10px", width: "100%"}}>
																				<Progress bar color={this.getColor(procedure.CategoryID)} value={this.getBarValue(procedure)} />
																			</Progress>
																			{
																				//<span className="float-right" style={{color:'#ffc10e', width: "15%"}}>{this.state.userCurrencySymbol}{procedure.Goal}</span>
																			}
																		</Col>
																	</Row>
																</Fragment>
															) : (
																<Fragment>
																</Fragment>
															)}
															</Fragment>
											      ))}
														</div>
													)}
											</div>
										</div>
										<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
											<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Step Forward">
												<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
											</Button>
										</div>
									</Row>
									</Fragment>
								}
								{[3, 4, 5].includes(selectedCategoryID) &&
									<Fragment>
									<Row className="align-items-center">
										<div style={{ width: '5%', margin: '0 auto', height: '100%' }}>
											<Button size="sm" color="link" onClick={() => this.stepBack()} title="Step Back">
												<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
											</Button>
										</div>
										<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
											<div className="ml-4 mt-1">
													{this.state.noDataForDevices ? (
														<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
															<h5>No data for user's devices</h5>
														</div>
													) : (
														<div className="">
												{selectedProcedures.map((procedure, i) => (
															<Fragment>
															<Row key={i} className={i>0 ? "mt-3" : ""}>
																<Col xs="12">
																	<div className="text-left" style={{ width: "30%", float: "left" }}>
																		{procedure.Amount > 0 ? (
																			<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(procedure.Amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
																		) : (
																			<span style={{ width: "50px" }}>{this.state.userCurrencySymbol}{(0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} earned</span>
																		)}
																	</div>
																	<div className="text-center" style={{ width: "40%", float: "left" }}>
																		{procedure.total > 0 && procedure.Price > 0 ? (
																			<span>({procedure.Name})</span>
																		) : (
																			<span>({procedure.Name})</span>
																		)}
																	</div>
																	<div className="text-right" style={{ width: "30%", float: "left" }}>
																		{procedure.Amount > 0 ? (
																			<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
																		) : (
																			<span>{procedure.Goal && procedure.Goal!=0 ? "Goal "+this.state.userCurrencySymbol+(procedure.Goal).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : "No Goal"}</span>
																		)}
																	</div>
																</Col>
															</Row>
															{procedure.Goal && procedure.Goal!=0 && procedure.Goal!="" && procedure.total>0 ? (
																<Fragment>
																	<Row>
																		<Col xs="12" md="12" lg="12" className="text-right">
																			<Progress multi className="mt-1 float-left" style={{ height: "10px", width: "100%"}}>
																				<Progress bar color={this.getColor(procedure.CategoryID)} value={this.getBarValue(procedure)} />
																			</Progress>
																			{
																				//<span className="float-right" style={{color:'#ffc10e', width: "15%"}}>{this.state.userCurrencySymbol}{procedure.Goal}</span>
																			}
																		</Col>
																	</Row>
																</Fragment>
															) : (
																<Fragment>
																</Fragment>
															)}
															</Fragment>
											      ))}
														</div>
													)}
											</div>
										</div>
										<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
											<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Step Forward">
												<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
											</Button>
										</div>
									</Row>
									</Fragment>
								}
								</Fragment>
							)}
						</div>
					)}
					{this.state.currentDataSetting == 0 || this.state.currentDataSetting == 3 ? (
						<Fragment>
						{this.state.currentDataSetting != 0 &&
							<Fragment>
							<Row className="mt-5">
								<Col lg="12" xl="6" className="text-right">
									<div className="float-left" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
									</div>
								</Col>
								<Col lg="12" xl="6" className="">
									<div className="float-left text-right" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
									</div>
									{
										// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
										// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go" disabled={this.state.currentDataSetting != 3}>
										// 	GO
										// </Button>
										// </div>
									}
								</Col>
							</Row>
							</Fragment>
						}
						</Fragment>
					) : (
						<Fragment>
						<Row className="mt-5">
							<Col lg="12" xl="6" className="text-right">
								<div className="float-left" style={{ minWidth: '10%' }}>
									<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
								</div>
								<div className="float-left ml-1" style={{ minWidth: '75%' }}>
									<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
								</div>
							</Col>
							<Col lg="12" xl="6" className="">
								<div className="float-left text-right" style={{ minWidth: '10%' }}>
									<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
								</div>
								<div className="float-left ml-1" style={{ minWidth: '75%' }}>
									<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
								</div>
								{
									// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
									// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go">
									// 	GO
									// </Button>
									// </div>
								}
							</Col>
						</Row>
						</Fragment>
					)}
				</CardBody>
			</Card>

		);
	}
}

export default ReturnOnInvestment;
